import { useEffect } from "react";

export default function ChatMovidesk() {
  useEffect(() => {
    if (document.getElementById("movidesk-chat-script")) return;

    window.mdChatClient = "A4BA53A055264029908AD2E0ED083700";

    // Cria o script de carregamento
    const script = document.createElement("script");
    script.id = "movidesk-chat-script";
    script.src = "https://chat.movidesk.com/Scripts/chat-widget.min.js";
    script.async = true;

    document.body.appendChild(script);

    // Limpa ao sair da tela administrativa (remove o chat)
    return () => {
      const existing = document.getElementById("movidesk-chat-script");
      if (existing) existing.remove();

      // Remove possíveis elementos do chat injetados no DOM
      const chatContainers = document.querySelectorAll("[id^='md-']");
      chatContainers.forEach((el) => el.remove());
    };
  }, []);

  return null;
}
